// src/utils/context/createGenericContext.tsx
import React, { createContext, useContext, useState } from "react";

export function createGenericContext(defaultValue) {
  const Context = createContext(null);

  const Provider = ({ children }) => {
    const [value, setValue] = useState(defaultValue);
    return (
      <Context.Provider value={{ value, setValue }}>
        {children}
      </Context.Provider>
    );
  };

  const useGeneric = () => {
    const context = useContext(Context);
    if (!context) {
      throw new Error("useGeneric must be used within its Provider");
    }
    return context;
  };

  return [Provider, useGeneric];
}
